import React, { Component } from "react";
import { FaCircleInfo } from "react-icons/fa6";
import { connect } from "react-redux";
import { Link, Redirect, RouteProps } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import styled from "styled-components";
import { ClientModel } from "../../entities/client.model";
import { CompanyModel } from "../../entities/company.model";
import AreaFields, { AreaSelection } from "../address/area-fields.component";
import Sidebar from "../../layouts/main/sidebar";
import store from "../../store";
import "./account.scss";
import "./company.scss";

interface AccountProps { }
interface AccountState {
  loading: boolean;
  errorMsg: string;
  successMsg: string;
  redirect: string;
  password: string;
  passwordMatch: string;
  client: ClientModel;
}
interface CompanyState {
  company: CompanyModel;
  originalCompany: CompanyModel;
  fetchedCompany: boolean;
  companyFound: boolean;
  isManager: boolean;
  companyLoading: boolean;
  companyErrorMsg: string;
  companySuccessMsg: string;
}
type Props = AccountProps & RouteProps;
type State = AccountState & CompanyState;

const mapStateToProps = (state: any) => ({ client: state.client });

const FormGroup = styled.div`
  margin-top: 20px;
`;
const MyLabel = styled.div`
  margin-bottom: 10px;
  font-weight: 600;
`;
const WhiteTitle = styled.div`
  margin-top: 20px;
  font-weight: 600;
`;

class ClientAccountPage extends Component<Props, State> {
  clientToken: string | null = null;
  originalClient: ClientModel = new ClientModel();

  constructor(props: any) {
    super(props);
    this.state = {
      // client
      loading: false,
      errorMsg: "",
      successMsg: "",
      redirect: "",
      password: "",
      passwordMatch: "",
      client: new ClientModel(),
      // company
      company: new CompanyModel(),
      originalCompany: new CompanyModel(),
      fetchedCompany: false,
      companyFound: false,
      isManager: false,
      companyLoading: false,
      companyErrorMsg: "",
      companySuccessMsg: "",
    };
    // bind client
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onOwnNameChange = this.onOwnNameChange.bind(this);
    this.onParentNameChange = this.onParentNameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onPasswordMatchChange = this.onPasswordMatchChange.bind(this);
    this.onTownChange = this.onTownChange.bind(this);
    this.onDistrictChange = this.onDistrictChange.bind(this);
    this.onAddressUnitChange = this.onAddressUnitChange.bind(this);
    this.onStreetChange = this.onStreetChange.bind(this);
    this.onZipCodeChange = this.onZipCodeChange.bind(this);
    // bind company
    this.onCompanyChange = this.onCompanyChange.bind(this);
    this.saveCompany = this.saveCompany.bind(this);
  }

  componentDidMount() {
    const token = localStorage.getItem("clientToken");
    if (token && token !== "undefined") {
      this.clientToken = token;
      // load client
      fetch(process.env.REACT_APP_API_URL + "client", {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: token,
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((j: any) => {
              const c = j.client;
              if (!c.town) c.town = "";
              if (!c.district) c.district = "";
              if (!c.unit) c.unit = "";
              if (!c.street) c.street = "";
              if (!c.zipcode) c.zipcode = "";
              this.setState({ client: c });
              this.originalClient = { ...c };
              store.dispatch({ type: "authenticateClient", client: j.client });
              if (j.client.company) {
                this.getCompanyDetails();
              }
            });
          }
        })
        .catch(() => this.setState({ redirect: "/" }));
      // load company
      this.getCompanyDetails();
    } else {
      store.dispatch({ type: "redirectUrl", data: window.location.pathname });
      this.setState({ redirect: "/" });
    }
  }

  // --- Company ---
  getCompanyDetails() {
    const token = localStorage.getItem("clientToken");
    if (!token) {
      this.setState({ fetchedCompany: true });
      return;
    }
    fetch(`${process.env.REACT_APP_API_URL}client/company`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: token,
        "Content-Type": "application/json",
      },
    })
      .then((r) => r.json())
      .then((j: any) => {
        if (j.company?.id) {
          const c = j.company as CompanyModel;
          this.setState({
            company: c,
            originalCompany: { ...c },
            companyFound: true,
          });
        }
        if (store.getState().client.role === "MANAGER") {
          this.setState({ isManager: true });
        }
        this.setState({ fetchedCompany: true });
      })
      .catch(() => this.setState({ fetchedCompany: true }));
  }

  onCompanyChange(e: any) {
    const { name, value } = e.target;
    this.setState((s) => ({
      company: { ...s.company, [name]: value },
    }));
  }

  onCompanyAreaChange = (area: AreaSelection) => {
    this.setState((s) => ({
      company: { ...s.company, deliveryAreaId: area.areaId, town: area.town, district: area.district, unit: area.unit },
    }));
  }

  /** True when the address part of the company form differs from what was loaded. */
  companyAddressChanged(): boolean {
    const { company, originalCompany } = this.state;
    return (
      company.deliveryAreaId !== originalCompany.deliveryAreaId ||
      company.town !== originalCompany.town ||
      company.district !== originalCompany.district ||
      company.unit !== originalCompany.unit ||
      company.street !== originalCompany.street
    );
  }

  /** The address is only checked when it is being set or changed; an old free-text one can stay while the rest is edited. */
  companyAddressIsBeingSet(): boolean {
    return !this.state.companyFound || this.companyAddressChanged();
  }

  validateCompany(): boolean {
    const { company, originalCompany } = this.state;
    if (!company.name) {
      this.setState({ companyErrorMsg: "Байгууллагын нэр оруулна уу" });
      this.scrollUp();
      return false;
    }
    if (this.companyAddressIsBeingSet()) {
      if (!company.town) {
        this.setState({ companyErrorMsg: "Хот сонгоно уу" });
        this.scrollUp();
        return false;
      }
      if (!company.district) {
        this.setState({ companyErrorMsg: "Дүүрэг сонгоно уу" });
        this.scrollUp();
        return false;
      }
      // the khoroo has to be picked from the list: a saved free-text address has no id, so a change needs a new pick
      if (!company.deliveryAreaId) {
        this.setState({ companyErrorMsg: "Хороо сонгоно уу" });
        this.scrollUp();
        return false;
      }
      if (!company.street) {
        this.setState({ companyErrorMsg: "Дэлгэрэнгүй хаяг оруулна уу" });
        this.scrollUp();
        return false;
      }
    }
    if (
      company.name === originalCompany.name &&
      company.register === originalCompany.register &&
      company.phone === originalCompany.phone &&
      company.town === originalCompany.town &&
      company.district === originalCompany.district &&
      company.unit === originalCompany.unit &&
      company.deliveryAreaId === originalCompany.deliveryAreaId &&
      company.street === originalCompany.street &&
      company.zipcode === originalCompany.zipcode
    ) {
      this.setState({ companyErrorMsg: "Өөрчлөлт байхгүй байна" });
      this.scrollUp();
      return false;
    }
    this.setState({ companyErrorMsg: "" });
    return true;
  }

  saveCompany() {
    if (!this.validateCompany()) return;
    this.setState({
      companyLoading: true,
      companyErrorMsg: "",
      companySuccessMsg: "",
    });
    const token = localStorage.getItem("clientToken");
    this.setState({ companyLoading: true });
    const company = this.state.company as any;
    const payload: any = {
      name: company.name,
      register: company.register,
      phone: company.phone,
      zipcode: company.zipcode,
    };
    if (this.companyAddressIsBeingSet()) {
      // saved by the picked khoroo's id; the backend fills in the town / district / unit text.
      // Left out when the address was not touched, so an old free-text address stays exactly as it is.
      payload.deliveryAreaId = company.deliveryAreaId;
      payload.street = company.street;
    }

    fetch(`${process.env.REACT_APP_API_URL}client/company`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: token!,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        this.setState({ companyLoading: false });
        if (res.ok) {
          // emit generic successMsg for the shared bottom‐message block
          this.setState({ successMsg: "Амжилттай хадгаллаа" });
          // reload the saved company
          this.getCompanyDetails();
        } else {
          this.setState({ companyErrorMsg: "Хадгалахад алдаа гарлаа" });
        }
        this.scrollUp();
      })
      .catch(() => {
        this.setState({
          companyLoading: false,
          companyErrorMsg: "Сүлжээний алдаа",
        });
        this.scrollUp();
      });
  }

  // --- Client handlers & validators (unchanged) ---
  onEmailChange(e: any) {
    const client = this.state.client;
    client.email = e.target.value;
    this.setState({ client });
  }
  onPhoneChange(e: any) {
    const client = this.state.client;
    client.phone = e.target.value;
    this.setState({ client });
  }
  onOwnNameChange(e: any) {
    const client = this.state.client;
    client.ownName = e.target.value;
    this.setState({ client });
  }
  onParentNameChange(e: any) {
    const client = this.state.client;
    client.parentName = e.target.value;
    this.setState({ client });
  }
  onPasswordChange(e: any) {
    this.setState({ password: e.target.value });
  }
  onPasswordMatchChange(e: any) {
    this.setState({ passwordMatch: e.target.value });
  }
  onClientAreaChange = (area: AreaSelection) => {
    const client = this.state.client;
    Object.assign(client, { deliveryAreaId: area.areaId, town: area.town, district: area.district, unit: area.unit });
    this.setState({ client });
  }
  onTownChange(e: any) {
    const client = this.state.client;
    client.town = e.target.value;
    this.setState({ client });
  }
  onDistrictChange(e: any) {
    const client = this.state.client;
    client.district = e.target.value;
    this.setState({ client });
  }
  onAddressUnitChange(e: any) {
    const client = this.state.client;
    client.unit = e.target.value;
    this.setState({ client });
  }
  onStreetChange(e: any) {
    const client = this.state.client;
    client.street = e.target.value;
    this.setState({ client });
  }
  onZipCodeChange(e: any) {
    const client = this.state.client;
    client.zipcode = e.target.value;
    this.setState({ client });
  }

  validateMyDetails(): boolean {
    this.setState({ successMsg: "" });
    if (!this.state.client.parentName) {
      this.setState({ errorMsg: "Та овогоо оруулна уу" });
      return false;
    }
    if (!this.state.client.ownName) {
      this.setState({ errorMsg: "Та өөрийн нэрээ оруулна уу" });
      return false;
    }
    if (!this.state.client.email) {
      this.setState({ errorMsg: "Та имэйл оруулна уу" });
      return false;
    }
    if (!this.validateEmail()) {
      this.setState({ errorMsg: "Имэйл буруу форматтай байна" });
      return false;
    }
    if (!this.state.client.phone) {
      this.setState({ errorMsg: "Та гар утасны дугаар оруулна уу" });
      return false;
    }
    if (!this.validatePhone()) {
      this.setState({ errorMsg: "Та гар утасны дугаараа шалгаж үзнэ үү" });
      return false;
    }
    // no "no-change" check here any more
    return true;
  }

  validateEmail() {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.state.client.email).toLowerCase());
  }
  validatePhone() {
    var re =
      /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/;
    return re.test(String(this.state.client.phone).toLowerCase());
  }

  validateAddress(): boolean {
    this.setState({ successMsg: "" });
    if (!this.state.client.town) {
      this.setState({ errorMsg: "Хот сонгоно уу" });
      return false;
    }
    if (!this.state.client.district) {
      this.setState({ errorMsg: "Дүүрэг сонгоно уу" });
      return false;
    }
    // the khoroo has to be picked from the list (a saved free-text address has no id and must be picked again)
    if (!this.state.client.deliveryAreaId) {
      this.setState({ errorMsg: "Хороо сонгоно уу" });
      return false;
    }
    if (!this.state.client.street) {
      this.setState({ errorMsg: "Дэлгэрэнгүй хаяг оруулна уу" });
      return false;
    }
    // no "no-change" check here any more
    return true;
  }

  /**
   * return true if any of the three sections (personal, address, company)
   * have changed vs. their originals
   */
  hasAnyChange(): { personal: boolean; address: boolean; company: boolean } {
    const c = this.state.client;
    const oc = this.originalClient;
    const personalChanged =
      c.parentName !== oc.parentName ||
      c.ownName !== oc.ownName ||
      c.email !== oc.email ||
      c.phone !== oc.phone;

    const addressChanged =
      c.town !== oc.town ||
      c.district !== oc.district ||
      c.unit !== oc.unit ||
      c.deliveryAreaId !== oc.deliveryAreaId ||
      c.street !== oc.street ||
      c.zipcode !== oc.zipcode;

    const comp = this.state.company;
    const ocp = this.state.originalCompany;
    const companyChanged =
      comp.name !== ocp.name ||
      comp.register !== ocp.register ||
      comp.phone !== ocp.phone ||
      comp.town !== ocp.town ||
      comp.district !== ocp.district ||
      comp.unit !== ocp.unit ||
      comp.deliveryAreaId !== ocp.deliveryAreaId ||
      comp.street !== ocp.street ||
      comp.zipcode !== ocp.zipcode;

    return {
      personal: personalChanged,
      address: addressChanged,
      company: companyChanged,
    };
  }

  saveMyDetails = () => {
    if (!this.validateMyDetails()) {
      this.scrollUp();
      return;
    }
    this.postClient({
      ownName: this.state.client.ownName,
      parentName: this.state.client.parentName,
      email: this.state.client.email,
      phone: this.state.client.phone,
    });
  };
  saveAddress = () => {
    if (!this.validateAddress()) {
      this.scrollUp();
      return;
    }
    this.postClient({
      // saved by the picked khoroo's id; the backend fills in the town / district / unit text
      deliveryAreaId: this.state.client.deliveryAreaId,
      street: this.state.client.street,
      zipcode: this.state.client.zipcode,
    });
  };
  postClient(data: any) {
    this.setState({ errorMsg: "", loading: true });
    fetch(process.env.REACT_APP_API_URL + "client", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: this.clientToken || "",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (!res.ok) {
          res.json().then((resJson) => {
            this.setState({ errorMsg: resJson.errorMsg, loading: false });
          });
        } else {
          this.setState({
            errorMsg: "",
            successMsg: "Амжилттай хадгаллаа",
            loading: false,
          });
          this.originalClient = Object.assign({}, this.state.client);
          store.dispatch({
            type: "authenticateClient",
            client: this.state.client,
          });
          var me = this;
          setTimeout(
            function () {
              me.setState({ successMsg: "" });
            }.bind(this),
            3000
          );
          this.scrollUp();
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: "Сүлжээнд алдаа гарлаа", loading: false });
        this.scrollUp();
      });
  }
  scrollUp() {
    const el = document.getElementById("my-form");
    if (el) el.scrollIntoView();
  }
  // inside class ClientAccountPage
  saveAll = () => {
    // clear out old messages
    this.setState({
      errorMsg: "",
      companyErrorMsg: "",
      successMsg: "",
      companySuccessMsg: "",
    });

    const changes = this.hasAnyChange();
    if (!changes.personal && !changes.address && !changes.company) {
      this.setState({ errorMsg: "Өөрчлөлт байхгүй байна" });
      this.scrollUp();
      return;
    }

    // personal  address go to same POST /client
    if (changes.personal || changes.address) {
      // validate required fields first
      if (changes.personal && !this.validateMyDetails()) {
        this.scrollUp();
        return;
      }
      if (changes.address && !this.validateAddress()) {
        this.scrollUp();
        return;
      }
      // build payload only with changed keys
      const payload: any = {};
      if (changes.personal) {
        payload.parentName = this.state.client.parentName;
        payload.ownName = this.state.client.ownName;
        payload.email = this.state.client.email;
        payload.phone = this.state.client.phone;
      }
      if (changes.address) {
        payload.deliveryAreaId = this.state.client.deliveryAreaId;
        payload.street = this.state.client.street;
        payload.zipcode = this.state.client.zipcode;
      }
      this.postClient(payload);
    }

    // company is separate endpoint
    if (changes.company) {
      this.saveCompany();
    }
  };

  render() {
    if (this.state.redirect) return <Redirect to={this.state.redirect} />;
    const logout = () => {
      localStorage.removeItem("clientToken");
      store.dispatch({ type: "logout" });
    };
    const closeMenu = () => console.log("close");

    return (
      <div className="page margin-top-50">
        <div className="account-layout">
          <Sidebar onLogout={logout} closeMenu={closeMenu} />
          <div className="account-container">
            {this.state.loading && (
              <div className="dimmer">
                <div className="loader medium" />
              </div>
            )}
            <h3>Хувийн мэдээлэл</h3>
            <div className="account-accordion">
              <div className="accordion-content">
                <form
                  className="form widths-equal"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="form-group">
                    <MyLabel>Овог</MyLabel>
                    <input
                      type="text"
                      required
                      placeholder="Овог"
                      value={this.state.client.parentName}
                      onChange={this.onParentNameChange}
                    />
                  </div>
                  <div className="form-group">
                    <MyLabel>Нэр</MyLabel>
                    <input
                      type="text"
                      required
                      placeholder="Нэр"
                      value={this.state.client.ownName}
                      onChange={this.onOwnNameChange}
                    />
                  </div>
                  <div className="form-group">
                    <MyLabel>Имэйл</MyLabel>
                    <input
                      type="email"
                      required
                      placeholder="Имэйл"
                      value={this.state.client.email}
                      onChange={this.onEmailChange}
                    />
                  </div>
                  <div className="form-group">
                    <MyLabel>Гар утас</MyLabel>
                    <input
                      type="text"
                      required
                      placeholder="Гар утас"
                      value={this.state.client.phone}
                      onChange={this.onPhoneChange}
                    />
                  </div>
                </form>
              </div>
              <h3>Миний хаяг</h3>

              <div className="accordion-content">
                <form
                  className="form widths-equal"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="form-group-big">
                    <AreaFields
                      testIdPrefix="client-address"
                      areaId={this.state.client.deliveryAreaId}
                      town={this.state.client.town || ""}
                      district={this.state.client.district || ""}
                      onChange={this.onClientAreaChange}
                      legacy={this.originalClient.deliveryAreaId ? null : {
                        town: this.originalClient.town || "",
                        district: this.originalClient.district || "",
                        unit: this.originalClient.unit || "",
                      }}
                    />
                  </div>
                  <div className="form-group-big">
                    <MyLabel>Дэлгэрэнгүй</MyLabel>
                    <textarea
                      required
                      value={this.state.client.street}
                      onChange={this.onStreetChange}
                    />
                  </div>
                </form>
              </div>

              <h3>Байгууллагын мэдээлэл</h3>
              <div className="account-companyInfo">
                {!this.state.company ? <>
                  <FaCircleInfo color="#FFAA00" size={15} />
                  <div>
                    <p>
                      Та байгууллагын мэдээлэллээ оруулснаар байгууллагын аккаунт
                      үүсгэх боломжтой.
                    </p>
                    <p>
                      Хэрвээ танай байгууллагыг өөр хэрэглэгч бүртгүүлсэн байгаа
                      бол та тухайн хэрэглэгчид хандана уу.
                    </p>
                  </div>
                </> : null}
              </div>
              <div className="accordion-content">
                {this.state.company?.clubMember ? (
                  <div className="pay-later">
                    <Icon name="star outline" />
                    <span>
                      Та клуб гишүүн бөгөөд клуб үнээр захиалга хийх эрхтэй
                    </span>
                  </div>
                ) : null}

                {this.state.companyFound ?
                  this.state.isManager ? 
                  <div className="company-controls">
                    <div className="company-control-item">
                      <Link className="link-to" to="/client/company/users">
                        <span>Байгууллагын хэрэглэгч нар</span>
                        <Icon name="angle right"></Icon>
                      </Link>
                    </div>
                    <div className="company-control-item">
                      <Link className="link-to" to="/client/company/orders">
                        <span>Захиалгууд</span>
                        <Icon name="angle right"></Icon>
                      </Link>
                    </div>
                    {Number(this.state.company?.childCompanyCount) > 0 ? (
                    <div className="company-control-item">
                      <Link className="link-to" to="/client/company/child-orders">
                        <span>Салбарын захиалгууд</span>
                        <Icon name="angle right"></Icon>
                      </Link>
                    </div>
                    ) : null}
                  </div>
                    : null
                  :
                  <div>
                    <p>
                      <Icon name="info circle" />
                      Та байгууллагын мэдээллээ оруулснаар байгууллагын аккаунт үүсгэх боломжтой.
                    </p>
                    <p>
                      <Icon name="info circle" />
                      Хэрвээ танай байгууллагыг өөр хэрэглэгч бүргүүлсэн байгаа бол та тухайн хэрэглэгчид хандана уу.
                    </p>
                  </div>
                }

                {!this.state.fetchedCompany ? null : (
                  <form
                    className="form widths-equal"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    {this.state.companyErrorMsg && (
                      <div className="form-group error-msg">
                        {this.state.companyErrorMsg}
                      </div>
                    )}
                    <div className="form-group">
                      <MyLabel>Байгууллагын нэр</MyLabel>
                      <input
                        data-testid="client-company-name-input"
                        name="name"
                        type="text"
                        required
                        value={this.state.company.name}
                        onChange={this.onCompanyChange}
                        disabled={
                          this.state.companyFound && !this.state.isManager
                        }
                      />
                    </div>
                    <div className="form-group">
                      <MyLabel>Регистр</MyLabel>
                      <input
                        data-testid="client-company-register-input"
                        name="register"
                        type="text"
                        value={this.state.company.register}
                        onChange={this.onCompanyChange}
                        disabled={
                          this.state.companyFound && !this.state.isManager
                        }
                      />
                    </div>
                    <div className="form-group">
                      <MyLabel>Утас</MyLabel>
                      <input
                        data-testid="client-company-phone-input"
                        name="phone"
                        type="text"
                        value={this.state.company.phone}
                        onChange={this.onCompanyChange}
                        disabled={
                          this.state.companyFound && !this.state.isManager
                        }
                      />
                    </div>
                    <div className="form-group-big">
                      <AreaFields
                        testIdPrefix="client-company"
                        areaId={this.state.company.deliveryAreaId}
                        town={this.state.company.town || ""}
                        district={this.state.company.district || ""}
                        onChange={this.onCompanyAreaChange}
                        disabled={
                          this.state.companyFound && !this.state.isManager
                        }
                        legacy={this.state.companyFound && !this.state.originalCompany.deliveryAreaId ? this.state.originalCompany : null}
                      />
                    </div>
                    <div className="form-group-big">
                      <MyLabel>Дэлгэрэнгүй хаяг</MyLabel>
                      <textarea
                        data-testid="client-company-street-input"
                        name="street"
                        required
                        value={this.state.company.street}
                        onChange={this.onCompanyChange}
                        disabled={
                          this.state.companyFound && !this.state.isManager
                        }
                      />
                    </div>

                    <button
                      data-testid="client-company-save-button"
                      type="button"
                      onClick={this.saveAll}
                      disabled={this.state.loading || this.state.companyLoading}
                    >
                      {this.state.loading || this.state.companyLoading
                        ? "Хадгалж байна..."
                        : "Хадгалах"}
                    </button>
                  </form>
                )}
                <div style={{ marginTop: "20px" }}>
                  {this.state.errorMsg && (
                    <div className="form-group error-msg">
                      {this.state.errorMsg}
                    </div>
                  )}
                  {this.state.successMsg && (
                    <div className="form-group success-msg">
                      {this.state.successMsg}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(ClientAccountPage);
